import { NumericBoolean } from '@/types/general/NumericBoolean.ts';

export interface BoaInfoRaw {
    r: string[];
    noticeT: number;
    targetT: number;
    targetD: number;
    totalD: number;
    PChange: number;
    netVol: number;
    avgP: number;
    boaU: boolean;
}

export interface BoaAlternativeBmuInfo {
    altBmu: string;
    r: Array<string>;
    bidP: number;
    offerP: number;
    actVol: number;
    absPD: number;
    diffC: number;
}

export interface AcceptedVolumes {
    unflagged: number | null;
    soFlagged: number | null;
    storFlagged: number | null;
    cadlFlagged: number | null;
    totalFlagged?: number | null;
}

export enum BidOnTableType {
    TurnOn = 'TurnOn',
    TurnOff = 'TurnOff',
    TurnUp = 'TurnUp',
    TurnDown = 'TurnDown',
}

export interface IBoaItem extends IBoaIdentificationProperties {
    isAccepted: number;
    volumeComparison: number | null;
    terreAccepted: number | null;
    offerPrice: number;
    bidPrice: number;
    terreFlag: boolean;
    soFlag: boolean;
    storFlag: boolean;
    cadlFlag: boolean;
    cost: number;
    timeAccepted: string;
    enumType: number;
    colour: string;
    fuelType: string;
    fuelEnum: number;
    hasBoaWarning: boolean;
    tooltipOverride: string | null;
    isAnalytic: boolean;
    selected: boolean;
    show: boolean;
    theoretical: boolean;
    nonBmPrediction: boolean;
    dpForSummary: number | null;
    aggregated: boolean;
    allBoaInfoRaw: BoaInfoRaw[];
    altBmuInfoRaw: BoaAlternativeBmuInfo[]; // Assuming this can be any array since no information was provided
    allBoaReasons: string;
    additionalBsadData: {
        assetId: string;
        serviceType: string;
        tenderedStatus: string;
        partyId: string;
        fuelType: string;
        bsadType: number;
        estimatingAsdpEndTime: boolean;
    } | null; // Assuming this can be any or null since no type information was provided
    isMissingBsad: boolean;
    sync: boolean;
    acceptedVolumes: AcceptedVolumes;
    sel: number;
    mzt: number;
    ndb: number;
    ndo: number;
    ndz: number;
    mnzt: number;
    mdv: number | null;
    mdp: number | null;
    coords: [number, number];
    volume: number;
    mainPrice: number;
    bidOnTableTypeEnum: BidOnTableType;
    editedVolume: number | null;
    editedPrice: number | null;
    flagOverrides: Array<FlagOptions>;
    maxAcceptedVolume: number | null;
    isBsad: boolean;
    fakePlant?: boolean;
    _rowClass: string;
    _rowKey: string;
}

export interface IBoaIdentificationProperties {
    plantId: string;
    isBid: NumericBoolean;
    bodId: string;
    deltaId?: string;
}

export type FlagOptions = 'cadlFlag' | 'soFlag' | 'storFlag' | 'terreFlag' | 'isMissingBsad' | 'nonBmPrediction';
